export let detailSection = {};

export let ADItokenContainer = {
  backgroundColor: "rgba(98,52,18,0.8)",
  color: "white",
  justifyContent: "center",
};

export let ItemGrid = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
};

export let TGBox = {
  width: { md: "50%", xs: "80%" },
  textAlign: "left",
  margin: "10px auto",
};
export let Roadmapcontainer = {
  color: "white",
  margin: "8% auto",
  position: "relative",
  overflow: "hidden",
};
export let RoadmapItem = {
  margin: "10px auto",
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  flexWrap: "wrap",
  zIndex: "100",
};
export let RMIcons = {
  padding: "20px",
  background:
    "linear-gradient(98deg, rgba(221,114,8,0.958420868347339) 0%, rgba(55,52,48,1) 56%)",
  borderRadius: "50%",
  width: "fit-content",
};

export let RMCard = {
  width: { md: "30%", xs: "80%" },
  margin: "20px auto",
  padding: "20px",
  backgroundColor: "black",
  borderRadius: "20px",
  borderLeft: "2px solid rgba(98,52,18,0.8)",
  borderBottom: "2px solid rgba(98,52,18,0.8)",
};
export let RMTypo = { display: "flex", alignItems: "center" };
export let RMdoneicon = {
  background:
    "linear-gradient(98deg, rgba(221,114,8,0.958420868347339) 0%, rgba(55,52,48,1) 56%)",
  padding: "5px",
  borderRadius: "50%",
  marginRight: "20px",
};
export let RMarc = {
  width: "100%",
  height: "500px",
  border: "6px solid chocolate",
  borderRadius: "50%",
  boxShadow: "0px 0px 10px 10px rgba(98,52,18,0.8)",
  background:
    "linear-gradient(98deg, rgba(221,114,8,0.558420868347339) 0%, rgba(240,114,8,0.158420868347339) 56%)",
  position: "absolute",
  bottom: "-65%",
  display: { md: "block", xs: "none" },
};

export let FaqItem = {
  padding: { md: "10px", xs: "10px" },
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
};
export let questionBox = {
  width: { md: "45%", xs: "90%" },
  margin: "10px auto",
  padding: "0px",
};
export let questionTab = {
  backgroundColor: "rgba(98,52,14,0.8)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px",
};
export let IconBox = {
  height: "30px",
  width: "30px",
  borderRadius: "50%",
  backgroundColor: "chocolate",
};
export let FaqAnswer = {
  width: { md: "50%", xs: "90%" },
  minHeight: "450px",
  margin: "10px auto",
  display: "flex",
  alignItems: "center",
  padding: { md: "50px", xs: "10%" },
  border: "4px solid rgb(98,52,14)",
  backgroundColor: "rgba(40,40,40,0.5)",
};
export let footerbox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
};
export let paybutton = {
  width: "80px",
  padding: "10px",
  backgroundColor: "rgba(98,52,14,0.9)",
  textAlign: "center",
  borderRadius: "10px",
};

export let footericon = {
  margin: "0px auto",
  marginTop: "20px",
  padding: "10px 40px",
  display: "flex",
  alignItems: "center",
  justifyContent: {md:"space-between",xs:'center'},
  textAlign:'center',
  backgroundColor: "rgb(98,52,14)",
  flexWrap: "wrap",
  zIndex: "100",
};

export let FooterGr = {
  height: "300px",
  width: "300px",
  borderRadius: "50%",
  border: "8px solid rgba(98,52,14,0.8)",
  boxShadow: "0px 0px 10px 10px rgba(98,52,14,0.5)",
  position: "absolute",
  left: "36%",
  top: "30%",
  display: { md: "block", xs: "none" },
};
